/* Mr Pixel — slim sticky header. */
(function () {
  'use strict';

  function init() {
    var slim = document.querySelector('[data-mp-slim]');
    if (!slim) return;

    var wrapper = document.querySelector('.header-wrapper');
    var shown = false;

    slim.hidden = false;

    function thresholds() {
      var h = wrapper ? wrapper.offsetHeight : 120;
      return { on: h + 40, off: h - 10 };
    }

    function apply() {
      var y = window.scrollY || window.pageYOffset || 0;
      var t = thresholds();

      if (!shown && y > t.on) {
        shown = true;
        slim.classList.add('is-visible');
        document.documentElement.classList.add('mp-slim-on');
      } else if (shown && y < t.off) {
        shown = false;
        slim.classList.remove('is-visible');

        slim.classList.remove('is-settled');
        document.documentElement.classList.remove('mp-slim-on');
      }
    }

    slim.addEventListener('transitionend', function (event) {
      if (event.target !== slim || event.propertyName !== 'transform') return;
      if (slim.classList.contains('is-visible')) {
        slim.classList.add('is-settled');
      }
    });

    slim.addEventListener('click', function (event) {
      var link = event.target.closest('.mp-slim__item--has-children > .mp-slim__link');
      if (!link) return;

      if (window.matchMedia('(hover: hover)').matches) return;
      var item = link.parentNode;
      if (!item.classList.contains('is-open')) {
        event.preventDefault();
        var open = slim.querySelector('.mp-slim__item.is-open');
        if (open) open.classList.remove('is-open');
        item.classList.add('is-open');
      }
    });

    document.addEventListener('click', function (event) {
      if (slim.contains(event.target)) return;
      var open = slim.querySelector('.mp-slim__item.is-open');
      if (open) open.classList.remove('is-open');
    });

    slim.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = slim.querySelector('.mp-slim__item.is-open');
      if (open) open.classList.remove('is-open');
    });

    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply);
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
